import { render, staticRenderFns } from "./AuctionsPerformance.vue?vue&type=template&id=58592783&"
import script from "./AuctionsPerformance.vue?vue&type=script&lang=js&"
export * from "./AuctionsPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports